export const panelCollapseSize = 1;
export const panelMinSizeMain = 50;
export const panelMinSizeBig = 25;
export const panelMinSizeSmall = 20;
export const panelMinSizeVerySmall = 12;
export const editPanelMinSize = 35;
export const panelMinSizeVertical = 8;
export const panelGutterSize = 4;
export const panelGutterSizeBig = 8;
export const panelMaxSize = 99.99999;
export const panelMinSize = 0.00001;

export const mediaPanelSize = [100 - panelCollapseSize, panelCollapseSize];
export const chapterPanelSize = [panelMinSizeBig, 100 - panelMinSizeBig];
export const layerPanelSize = [50, 0];
export const wysiwygPanelSize = [panelMinSizeSmall, 100 - panelMinSizeSmall];
export const editPanelSize = [100 - editPanelMinSize, editPanelMinSize];

export enum MenuDesignClass {
	DEFAULT = 'w-auto',
	SEPARATE_FIRST_ENTRY = 'w-auto separate-first-entry',
	WHITE = ' medsurf-white w-auto'
}